import { createApiClient } from "@/app/lib/api/createClient";

export const apiClient = createApiClient({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:4000",
});
